import React from 'react';
import { companyInfo } from '../data/mock';

const Impressum = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-white mb-4">Impressum</h1>
          <p className="text-slate-300">Angaben gemäß § 5 TMG</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Anbieter</h2>
            <p className="text-slate-600 mb-6">
              {companyInfo.name}<br />
              Vertreten durch: {companyInfo.owner}<br />
              {companyInfo.address}
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Kontakt</h2>
            <p className="text-slate-600 mb-6">
              Telefon: {companyInfo.phone}<br />
              E-Mail: <a href={`mailto:${companyInfo.email}`} className="text-blue-600 hover:underline">{companyInfo.email}</a>
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Umsatzsteuer-ID</h2>
            <p className="text-slate-600 mb-6">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              [USt-IdNr. wird nach Anmeldung ergänzt]
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-slate-600 mb-6">
              {companyInfo.owner}<br />
              {companyInfo.address}
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Streitschlichtung</h2>
            <p className="text-slate-600 mb-6">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
              <br /><br />
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Haftung für Inhalte</h2>
            <p className="text-slate-600 mb-6">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Haftung für Links</h2>
            <p className="text-slate-600 mb-6">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">Urheberrecht</h2>
            <p className="text-slate-600 mb-6">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
